export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["After completing the trade, it will be closed. Internal funds will be transferred to the user."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to complete the trade?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, Complete"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, Keep Active"])}
}